<!-- ========== Left Sidebar Start ========== -->

<div class="vertical-menu aer-sidebar">

  <!-- LOGO -->
  <div class="navbar-brand-box d-none d-md-flex">
    <a [routerLink]="['/']" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/stp-logo.png" alt="" height="66">
      </span>
      <span class="logo-lg padding_l_30">
        <img src="assets/images/stp_logo.svg" alt="" height="66" width="167px">
      </span>
    </a>

    <a [routerLink]="['/']" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/stp-logo.png" alt="" height="66">
      </span>
      <span class="logo-lg padding_l_30">
        <img src="assets/images/stp_logo.svg" alt="" height="66" width="167px">
      </span>
    </a>
    <!-- stp-logo.png -->

    <div class="d-grid logo font_18 text-light" *ngIf="!isCondensed">
      <!-- <span class="st">Stamp the Passport</span> -->
    </div>

  </div>
  <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
    (click)="toggleMobileMenu($event)">
    <i class="ps-2 fa fa-fw fa-bars"></i>
  </button>

  <ngx-simplebar class="aer-nav-scroll" #componentRef>
    <nav class="aer-nav">
      <ng-container *ngFor="let item of menuItems">
        <div class="aer-section-title" *ngIf="item.isTitle">{{ item.label }}</div>

        <a *ngIf="!item.isTitle" class="aer-nav-link" [routerLink]="item.link" routerLinkActive="active">
          <i class="fas {{ item.icon }}"></i>
          <span>{{ item.label }}</span>
        </a>
      </ng-container>
    </nav>
  </ngx-simplebar>

  <!-- <div class="aer-sidebar-footer">
    CMS v4.9 &bull; Multi-Tax Label Engine
  </div> -->

</div>

<!-- ========== Left Sidebar End ========== -->
